import { IcoClose, IcoCopy } from "./icons";

export function CloneSheet({
  title,
  sourceTitle,
  takenNames,
  busy,
  err,
  onTitle,
  onConfirm,
  onClose,
}: {
  title: string;
  sourceTitle: string;
  takenNames: string[];
  busy: boolean;
  err: string;
  onTitle: (v: string) => void;
  onConfirm: () => void;
  onClose: () => void;
}) {
  const name = title.trim();
  const same = (a: string, b: string) => a.trim().toLocaleLowerCase("fr") === b.trim().toLocaleLowerCase("fr");
  const taken = name.length >= 2 && (same(name, sourceTitle) || takenNames.some((n) => same(n, name)));
  const ok = name.length >= 2 && !taken;
  return (
    <div className="sg-send-back" role="dialog" aria-label="Cloner le document">
      <div className="sg-send">
        <h2>Cloner</h2>
        <p className="sg-legal">Nommez la copie autrement que l’original. Les cases restent. Rien n’est créé tant que vous n’enregistrez pas.</p>
        {err ? <p className="sg-err">{err}</p> : null}
        <label>
          Nom du document
          <input
            className={`sg-input${taken ? " is-taken" : ""}`}
            type="text"
            value={title}
            autoFocus
            autoComplete="off"
            placeholder="Un nom qui n’existe pas encore"
            aria-invalid={taken}
            onChange={(e) => onTitle(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && ok && !busy) onConfirm();
              if (e.key === "Escape") onClose();
            }}
          />
        </label>
        {taken ? <p className="sg-err">Ce nom est déjà pris. Il doit s’appeler autrement.</p> : null}
        <div className="sg-send__actions">
          <button type="button" className="sg-btn ghost" disabled={busy} onClick={onClose}>
            <IcoClose />
            Annuler
          </button>
          <button type="button" className="sg-btn" disabled={!ok || busy} onClick={onConfirm}>
            <IcoCopy />
            {busy ? "Copie…" : "Enregistrer la copie"}
          </button>
        </div>
      </div>
    </div>
  );
}
